import * as c from '../constants/StudentSSDAccommodationsConstants'
import { DEFAULT_REQUEST_ERROR } from '../constants/MessageConstants'
import axios, { getServerErrorMessage } from '../utils/axios'

export const fetchStudentSSDAccommodations = studentId => dispatch => {
  dispatch({ type: c.FETCH_STUDENT_SSD_ACCOMMODATIONS_PENDING })
  return axios.get(`${Config.API_URL}/v1/ssdaccommodations/${studentId}`)
    .then(res => dispatch({ type: c.FETCH_STUDENT_SSD_ACCOMMODATIONS_FULFILLED, payload: { studentId, data: res.data } }))
    .catch(err => dispatch({ type: c.FETCH_STUDENT_SSD_ACCOMMODATIONS_REJECTED, payload: getServerErrorMessage(err || DEFAULT_REQUEST_ERROR) }))
}